import $ from "jquery";

const floatingBannerCta = {
  variables: {
    wrapper: ".floating-banner-cta",
    ctaLink: ".floating-banner-cta__button-link",
    mobileScrollThreshold: 900,
    desktopScrollThreshold: 300,
  },
  methods: {
    applyBackgroundColor: function () {
      $(floatingBannerCta.variables.wrapper).each(function () {
        const color = $(this).attr("data-bg-color");
        if (color) {
          $(this).css("background", color);
        }
      });
    },
    // Fades the banner in/out past a scroll threshold — a shorter one on
    // mobile (banner would otherwise cover content immediately) than desktop.
    handleScrollVisibility: function () {
      const $wrapper = $(floatingBannerCta.variables.wrapper);
      if (!$wrapper.length) {
        return;
      }
      $wrapper.hide();
      $(document).on("scroll", function () {
        const isMobile = $(window).width() < 768;
        const threshold = isMobile
          ? floatingBannerCta.variables.mobileScrollThreshold
          : floatingBannerCta.variables.desktopScrollThreshold;
        if ($(window).scrollTop() > threshold) {
          $wrapper.fadeIn(500);
        } else {
          $wrapper.fadeOut(500);
        }
      });
    },
    // If the CTA link is a same-page anchor (e.g. "#calculatorSection"),
    // smooth-scroll to it instead of navigating.
    handleAnchorScroll: function () {
      $(document).on("click", floatingBannerCta.variables.ctaLink, function (e) {
        const href = $(this).attr("href") || "";
        if (href.startsWith("#") && href.length > 1) {
          const $target = $(href);
          if ($target.length) {
            e.preventDefault();
            $target.get(0).scrollIntoView({ behavior: "smooth" });
          }
        }
      });
    },
    init: function () {
      this.applyBackgroundColor();
      this.handleScrollVisibility();
      this.handleAnchorScroll();
    },
  },
};

$(() => {
  if ($(floatingBannerCta.variables.wrapper).length > 0) {
    floatingBannerCta.methods.init();
  }
});
